import { ExamInterface, ExerciseInterface } from "../../../interfaces/examInterfaces";
import { MANIPULATE_EXERCISES_TYPES } from "../Reducers/ManipulateExercisesReducer";
import { DIALOGS } from "../../Dialogs/dialogReducer";
import { handleCloseDialog, resetDataPages, setExamData } from "./FunctionsMain";
import { getAppDispatch } from "../../../stores/dispatchStore";

export function changeExercises(
  newExercises: ExerciseInterface[],
  exercisesCopy: ExerciseInterface[],
  indexNewExercises: number,
  selectedObjectiveId: string,
  examData: ExamInterface
) {
  if (newExercises.length === 0) {
    handleCloseDialog(DIALOGS.SELECT_EXERCISES_EXAM_DIALOG);
    return;
  }
  const newExercisesSetRocket = setRocket(newExercises);
  resetDataPages();
  const updatedExercises = insertNewExercises(exercisesCopy, newExercisesSetRocket, indexNewExercises);
  updateExercises(updatedExercises, selectedObjectiveId, examData);
  handleCloseDialog(DIALOGS.SELECT_EXERCISES_EXAM_DIALOG);
}

function setRocket(newExercises: ExerciseInterface[]) {
  return newExercises.map((exercise) => ({
    ...exercise,
    showRocket: exercise.level === 3,
  }));
}

function insertNewExercises(
  exercisesCopy: ExerciseInterface[],
  newExercises: ExerciseInterface[],
  indexNewExercises: number
) {
  const updatedExercises = exercisesCopy.map((exercise) => ({ ...exercise }));

  const newExercisesWithIndex = newExercises.map((exercise, i) => ({
    ...exercise,
    index: indexNewExercises + i,
  }));

  updatedExercises.splice(indexNewExercises, 0, ...newExercisesWithIndex);

  updatedExercises.forEach((exercise, index) => {
    exercise.index = index;
  });

  return updatedExercises;
}

export function addExercise(exercise: ExerciseInterface, exercises: ExerciseInterface[]) {
  let updatedExercises = [...exercises];
  updatedExercises.push(exercise);
  updatedExercises.sort((a, b) => +a.id - +b.id);
  setNewExercises(updatedExercises);
}

export function removeExercise(id: string, exercises: ExerciseInterface[]) {
  const index = exercises.findIndex((exercise) => exercise.id === id);
  const updatedExercises = [...exercises];
  updatedExercises.splice(index, 1);
  setNewExercises(updatedExercises);
}

function updateExercises(updatedExercises: ExerciseInterface[], selectedObjectiveId: string, examData: ExamInterface) {
  if (selectedObjectiveId) {
    const objectiveId = +selectedObjectiveId;

    setExamData(
      {
        objectives: {
          ...examData.objectives,
          [objectiveId]: {
            ...examData.objectives[objectiveId],
            exercises: updatedExercises,
          },
        },
      },
      examData
    );
  }
}

export function moveExercise(
  currentIndex: number,
  newIndex: number,
  sortedExercises: ExerciseInterface[],
  selectedObjectiveId: string,
  examData: ExamInterface
) {
  let updatedExercises;
  if (sortedExercises) {
    updatedExercises = sortedExercises.map((exercise) => {
      if (exercise.index === currentIndex) {
        return { ...exercise, index: newIndex };
      } else if (exercise.index >= newIndex && exercise.index < currentIndex) {
        return { ...exercise, index: exercise.index + 1 };
      } else if (exercise.index <= newIndex && exercise.index > currentIndex) {
        return { ...exercise, index: exercise.index - 1 };
      }
      return exercise;
    });
    updateExercises(updatedExercises, selectedObjectiveId, examData);
  }
}

export function toggleRocket(
  index: number,
  sortedExercises: ExerciseInterface[],
  selectedObjectiveId: string,
  examData: ExamInterface
) {
  if (sortedExercises) {
    const updatedExercises = [...sortedExercises];
    const updatedExercise = { ...updatedExercises[index] };
    updatedExercise.showRocket = updatedExercise.showRocket === true ? false : true;
    updatedExercises[index] = updatedExercise;

    updateExercises(updatedExercises, selectedObjectiveId, examData);
  }
}

export function deleteExercise(
  index: number,
  sortedExercises: ExerciseInterface[],
  selectedObjectiveId: string,
  examData: ExamInterface
) {
  if (sortedExercises) {
    let updatedExercises = [...sortedExercises];

    updatedExercises.splice(index, 1);

    updatedExercises = updatedExercises.map((exercise) => {
      if (exercise.index >= index) {
        return { ...exercise, index: exercise.index - 1 };
      }
      return exercise;
    });
    updateExercises(updatedExercises, selectedObjectiveId, examData);
  }
}

export function changePoints(
  index: number,
  newPoints: string,
  sortedExercises: ExerciseInterface[],
  selectedObjectiveId: string,
  examData: ExamInterface
) {
  if (/^\d{0,2}$/.test(newPoints)) {
    const newPointsAsNumber = +newPoints;
    if (sortedExercises) {
      const updatedExercises = [...sortedExercises];
      const updatedExercise = { ...updatedExercises[index] };
      updatedExercise.points = newPointsAsNumber;
      updatedExercises[index] = updatedExercise;

      updateExercises(updatedExercises, selectedObjectiveId, examData);
    }
  }
}

function setImageZoom(imageZoom: string) {
  const dispatch = getAppDispatch();
  dispatch({ type: MANIPULATE_EXERCISES_TYPES.IMAGE_ZOOM, payload: imageZoom });
}

export function setNewExercises(newExercises: ExerciseInterface[]) {
  const dispatch = getAppDispatch();
  dispatch({ type: MANIPULATE_EXERCISES_TYPES.NEW_EXERCISES, payload: newExercises });
}
